import React from "react";
import "./outreach.css";

const Outreach = () => {
  return (
    <div className="page-content">
      <div className="outreach-container">

        {/* HERO */}
        <section className="outreach-hero">
          <h1 className="heading">Outreach at IHN</h1>
          <p> Indian Hospitality Network (IHN) successfully hosted its first by-invite-only Outreach Event at Le Meridien, New Delhi, bringing together pre-registered trade delegates, MICE planners, and IHN’s Exclusive Sellers Brigade. The day featured curated networking, an inspiring keynote by renowned business mentor Gomteshwar Jain on leadership and mindset transformation, followed by focused brand talks from leading hospitality, tourism, and travel entities. Interactive speed-networking sessions enabled meaningful collaborations, while the event concluded with the presentation of an all-inclusive Dubai FAM Trip to IHN’s top business contributor, reinforcing IHN’s role as a catalyst for growth, collaboration, and value creation within the hospitality ecosystem. </p>
        </section>

        {/* TEAM + VIDEO */}
        <section className="outreach-team">
          <div className="outreach-team-layout">

            {/* LEFT CONTENT */}
            <div className="outreach-bio-card">
              <h3>Outreach Event</h3>
              <p className="outreach-role">New Delhi | 28 March 2025</p>
              <p>
                Indian Hospitality Network (IHN) successfully hosted its inaugural Outreach Event on 28 March 2025 at Le Meridien, New Delhi, bringing together select trade delegates, MICE professionals, and IHN members. The by-invite-only event featured structured networking, an insightful keynote by business mentor Gomteshwar Jain, focused brand presentations, and high-impact collaboration—reinforcing IHN’s commitment to meaningful industry engagement and growth.

              </p>
            </div>

            {/* RIGHT VIDEO */}
            <div className="outreach-video">
                 <iframe
                src="https://www.youtube.com/embed/LJplT_dAcy8"
                title="IHN Outreach Event Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

          </div>
        </section>

      </div>
    </div>
  );
};

export default Outreach;
